<template>
  <div class="app-container">
    <el-row>
      <el-col :span="colSpan">
        <el-button type="primary" @click="onAdd()">{{ $t('ChannelThirdPartyPlatform.Add') }}</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" border size="mini" :height="minHeight" :stripe="true" style="margin-top:20px">
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Account')" prop="account" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.code')" prop="accountCode" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.API')" prop="apiServiceUrl" align="center" width="99"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.app_Key')" prop="appKey" align="center" width="150"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.name')" prop="appName" align="center" width="149"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.type')" prop="appType" align="center" width="149"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Authorizable')" prop="authAccount" align="center" width="103"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.address')" prop="authUrl" align="center" width="166"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Number')" prop="bpCode" align="center" width="105"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Callback')" prop="callBackUrl" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.traffic')" prop="certificateFlow" align="center" width="85"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Channel')" prop="channelCode" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Creator')" prop="createdBy" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Creation')" prop="creationDate" align="center" width="140"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Currency')" prop="currency" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Delete')" prop="deleteFlag" align="center" width="104">
        <template slot-scope="scope">
          <el-tag :type="scope.row.deleteFlag === 0 ? 'info' : 'success'">{{ scope.row.deleteFlag === 0 ? $t('ChannelThirdPartyPlatform.Normal') : $t('ChannelThirdPartyPlatform.Exception') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Last')" prop="lastUpdateDate" align="center" width="140"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.by')" prop="lastUpdatedBy" align="center" width="130"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Other')" prop="otherUrl" align="center" width="115"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Development')" prop="platformAddress" align="center" width="164"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Project')" prop="project" align="center" width="80"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Remarks')" prop="remark" align="center" width="200"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Status')" prop="status" align="center" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 0 ? 'info' : 'success'">{{ scope.row.status === 0 ? $t('ChannelThirdPartyPlatform.Normal') : $t('ChannelThirdPartyPlatform.Exception') }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.System')" prop="systemFlagCode" align="center" width="86"></el-table-column>
      <el-table-column :label="$t('ChannelThirdPartyPlatform.Tax')" prop="taxCode" align="center" width="80"></el-table-column>
      <!-- <el-table-column :label="$t('operationText')" align="center" fixed='right'>
        <template slot-scope="scope">
          <el-button type="text" @click="onChange(scope.row)">修改</el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="getData" />
  </div>
</template>

<script>
import axios from 'axios';
import DataForm from './DataForm.vue';
export default {
  name: 'BusinessSalesDailyDetailDown',
  components: {
    DataForm,
  },
  data() {
    return {
        colSpan: 6,
        tableData: [],
    };
  },
  computed: {
    minHeight() {
      return document.documentElement.clientHeight - 170;
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios({
            method: 'get',
            url: `http://52.65.239.14:8090/config/list`,
      }).then((res) => {
        this.tableData = res.data.data;
      });
    },

    // 新增
    onAdd() {
      this.$refs.DataForm.show();
    },

    // 修改
    // onChange(val) {
    //     console.log(val,'操作数据');
    // },
  }
};
</script>
